module.exports = __webpack_public_path__ + "img/LetterOpener.adbde2df.webp";